module.exports = __webpack_public_path__ + "img/fi-rr-layout-fluid.75b851a5.svg";